<template>
    <div class="ReCardTaskEnds">
        <template v-if="list.length==1">
            <ReCardTaskEnd 
                :objTaskEnd="list[0]" 
                :task_id="objTask.id" 
                :te_client_id="objTask.client_id" 
                :te_service_id="objTask.service_id" 
                :VER="objTask.VER" 
            />
        </template>
        <template v-else-if="list.length>1">
            <tabs 
                type="primary" 
                v-model="activeTab"
                tabContentClasses="tab-opt"
            
                inline
                round	
                v-loading.fullscreen.lock="$GVO.fullscreenLoading"
                element-loading-text="Загрузка данных..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"	
                class="card card-plain mt-3 mt-xl-0 task-tabs"
            >
                <tab-pane 
                    v-for="taskEnd in list" 
                    :id="''+taskEnd.id"
                    :key="taskEnd.id"
                    >
                    <template v-slot:label>
                        <span class="tab-label">
                            <span class="task-end-name">{{ taskEnd.name }}</span>
                        </span>
                    </template>
                    <ReCardTaskEnd
                        :objTaskEnd="taskEnd" 
                        :task_id="objTask.id" 
                        :te_client_id="objTask.client_id" 
                        :te_service_id="objTask.service_id" 
                        :VER="objTask.VER" 
                        :showHeader="false"
                    />
                </tab-pane>
            </tabs>
        </template>
    </div>
</template>
<script>
import ReCardTaskEnd from './ReCardTaskEnd.vue';
import { TabPane, Tabs } from 'src/components';
export default {
    components:{
        TabPane, Tabs,
        ReCardTaskEnd,
    },
    data(){
        return {
            activeTab: this.list.length>0?String(this.list[0].id):''
        }
    },
    watch:{
        list(value){
            if(value.lenght>0)
                this.activeTab = value[0].id
        }
    },
    props:{
        objTask: Object,
        list: Array,
    }
}
</script>
<style lang="scss">
	.ReCardTaskEnds {
		border: 1px solid rgba(1, 176, 224, 0.4);
		padding: 10px 10px 0;
        .ReCardTaskEnd{
            border-width: 0;
        }
        .task-tabs{
            .nav-link{
                max-height:50px;
                box-sizing: border-box;
                overflow: hidden;
            }
        }
        @media (max-width: 850px){
            .task-tabs>div>.nav{
                flex-wrap: wrap;
                .nav-item{
                    flex: 1 1 33.33%
                }
            }
        }
        @media (max-width: 525px){
            .task-tabs>div>.nav{
                flex-wrap: wrap;
                .nav-item{
                    flex: 1 1 50%;
                }
            }
            
        }
	}
</style>